import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import HybridBasicLayout from '../../layout/basic/hybrid.basic.layout.vue';
import GoBackArrow from '../../shared/GoBackArrow/go.back.arrow.vue';
import HybridButtonTwo from '../../shared/HybridButtonTwo/hybrid.button.two.vue';
import { CommonConfig } from '../../../configs/config.common';
import { CallNative } from '../../../services/EpicContextService/call.native';

@Component({
    components: {
        'layout': HybridBasicLayout,
        GoBackArrow,
        HybridButtonTwo
    }
})
export default class HybridCouponServicesAppointmentSuccess extends Vue {
    public data: string = '';

    public configs = new CommonConfig();

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public created() {
        CallNative.setNativeNavTitle('预约成功', 'Appointment Successful');
    }

    public mounted() {
    }

    public getRifoDesign(str: string) {
        return `${this.configs.rifoDesignAssetsUrl}/${str}`;
    }
}
